export const USER_BROWSER_STORAGE_ID = 'APW_OAUTH_USER_DATA';
export const AUTH_COOKIE_DOMAIN = '.bb.com.br';
export const HASH_COOKIE_KEY = 'APW_GCS_HASH';
export const ID_COOKIE_BB = 'idtoken_bb';
export const ID_COOKIE_GAS = 'gas.gcs.sign';